export const routes = [
  {
    path: '/',
    name: 'home.index',
    component: () => import('./home/Index.vue'),
    meta: {
      seo: require('./seo/home/Index.json'),
    },
  },
  {
    path: '/nueva-hipoteca',
    name: 'new-mortgage-page.index',
    component: () => import('./new-mortgage-page/Index.vue'),
    meta: {
      seo: require('./seo/new-mortgage-page/Index.json'),
    },
  },
  {
    path: '/simular-hipoteca/situacion-busqueda',
    name: 'funnel5-new.situation',
    component: () => import('./funnel5-new/Situation.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Situation.json'),
    },
  },
  {
    path: '/simular-hipoteca/plazo-compra',
    name: 'funnel5-new.purchase',
    component: () => import('./funnel5-new/Purchase.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Purchase.json'),
    },
  },
  {
    path: '/simular-hipoteca/herramienta',
    name: 'funnel5-new.tool',
    component: () => import('./funnel5-new/Tool.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Tool.json'),
    },
  },
  {
    path: '/simular-hipoteca/valor-vivienda',
    name: 'funnel5-new.price',
    component: () => import('./funnel5-new/Price.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Price.json'),
    },
  },
  {
    path: '/simular-hipoteca/datos-contacto',
    name: 'funnel5-new.contactData',
    component: () => import('./funnel5-new/ContactData.vue'),
    meta: {
      seo: require('./seo/funnel5-new/ContactData.json'),
    },
  },
  {
    path: '/simular-hipoteca/ubicacion-vivienda',
    name: 'funnel5-new.province',
    component: () => import('./funnel5-new/Province.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Province.json'),
    },
  },
  {
    path: '/simular-hipoteca/ocupacion-vivienda',
    name: 'funnel5-new.occupancy',
    component: () => import('./funnel5-new/Occupancy.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Occupancy.json'),
    },
  },
  {
    path: '/simular-hipoteca/estado-laboral',
    name: 'funnel5-new.workingStatus',
    component: () => import('./funnel5-new/WorkingStatus.vue'),
    meta: {
      seo: require('./seo/funnel5-new/WorkingStatus.json'),
    },
  },
  {
    path: '/simular-hipoteca/ahorros-disponibles',
    name: 'funnel5-new.savings',
    component: () => import('./funnel5-new/Savings.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Savings.json'),
    },
  },
  {
    path: '/simular-hipoteca/estado-laboral-inviable',
    name: 'funnel5-new.inviableWorkingStatus',
    component: () => import('./funnel5-new/InviableWorkingStatus.vue'),
    meta: {
      seo: require('./seo/funnel5-new/InviableWorkingStatus.json'),
    },
  },
  {
    path: '/simular-hipoteca/ingresos-familiares',
    name: 'funnel5-new.income',
    component: () => import('./funnel5-new/Income.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Income.json'),
    },
  },
  {
    path: '/simular-hipoteca/informacion-contacto',
    name: 'funnel5-new.contact',
    component: () => import('./funnel5-new/Contact.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Contact.json'),
    },
  },
  {
    path: '/simular-hipoteca/resultado-operacion',
    name: 'funnel5-new.inviableResults',
    component: () => import('./funnel5-new/InviableResults.vue'),
    meta: {
      seo: require('./seo/funnel5-new/InviableResults.json'),
    },
  },
  {
    path: '/simular-hipoteca/viabilidad-operacion',
    name: 'funnel5-new.results',
    component: () => import('./funnel5-new/Results.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Results.json'),
    },
  },
  {
    path: '/simular-hipoteca/viabilidad-hipoteca',
    name: 'funnel5-new.viability',
    component: () => import('./funnel5-new/Viability.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Viability.json'),
    },
  },
  {
    path: '/simular-hipoteca/reservar-cita',
    name: 'funnel5-new.appointment',
    component: () => import('./funnel5-new/Appointment.vue'),
    meta: {
      seo: require('./seo/funnel5-new/Appointment.json'),
    },
  },
  {
    path: '/simular-hipoteca/cita-reservada',
    name: 'funnel5-new.thankYou',
    component: () => import('./funnel5-new/ThankYou.vue'),
    meta: {
      seo: require('./seo/funnel5-new/ThankYou.json'),
    },
  },
  {
    path: '/documentacion/inicio',
    name: 'documentation.dispatcher',
    component: () => import('./documentation/Dispatcher.vue'),
    meta: {
      seo: require('./seo/documentation/Dispatcher.json'),
    },
  },
  {
    path: '/documentacion/documentos',
    name: 'documentation.documents',
    component: () => import('./documentation/Documents.vue'),
    meta: {
      seo: require('./seo/documentation/Documents.json'),
    },
  },
  {
    path: '/documentacion/titulares',
    name: 'documentation.owners',
    component: () => import('./documentation/Owners.vue'),
    meta: {
      seo: require('./seo/documentation/Owners.json'),
    },
  },
  {
    path: '/documentacion/informacion-personal',
    name: 'documentation.ownerData',
    component: () => import('./documentation/OwnerData.vue'),
    meta: {
      seo: require('./seo/documentation/OwnerData.json'),
    },
  },
  {
    path: '/documentacion/documento-identidad',
    name: 'documentation.identityDocument',
    component: () => import('./documentation/IdentityDocument.vue'),
    meta: {
      seo: require('./seo/documentation/IdentityDocument.json'),
    },
  },
  {
    path: '/documentacion/legal',
    name: 'documentation.legal',
    component: () => import('./documentation/Legal.vue'),
    meta: {
      seo: require('./seo/documentation/Legal.json'),
    },
  },
  {
    path: '/documentacion/conexion-ss',
    name: 'documentation.ssOtp',
    component: () => import('./documentation/SsOtp.vue'),
    meta: {
      seo: require('./seo/documentation/SsOtp.json'),
    },
  },
  {
    path: '/documentacion/nominas',
    name: 'documentation.payrolls',
    component: () => import('./documentation/Payrolls.vue'),
    meta: {
      seo: require('./seo/documentation/Payrolls.json'),
    },
  },
  {
    path: '/documentacion/cita',
    name: 'documentation.appointment',
    component: () => import('./documentation/Appointment.vue'),
    meta: {
      seo: require('./seo/documentation/Appointment.json'),
    },
  },
  {
    path: '/documentacion/cita-reservada',
    name: 'documentation.thankYou',
    component: () => import('./documentation/ThankYou.vue'),
    meta: {
      seo: require('./seo/documentation/ThankYou.json'),
    },
  },
  {
    path: '/camara',
    name: 'camara.index',
    component: () => import('./camara/Index.vue'),
    meta: {
      seo: require('./seo/camara/Index.json'),
    },
  },
  {
    path: '/solicitar-hipoteca',
    name: 'form-new.form',
    component: () => import('./form-new/Form.vue'),
    meta: {
      seo: require('./seo/form-new/Form.json'),
    },
  },
  {
    path: '/solicitar-hipoteca/thank-you',
    name: 'form-new.thankYou',
    component: () => import('./form-new/ThankYou.vue'),
    meta: {
      seo: require('./seo/form-new/ThankYou.json'),
    },
  },
  {
    path: '/solicitar-hipoteca/cita',
    name: 'form-new.appointment',
    component: () => import('./form-new/Appointment.vue'),
    meta: {
      seo: require('./seo/form-new/Appointment.json'),
    },
  },
  {
    path: '/solicitar-hipoteca/cita-reservada',
    name: 'form-new.appointmentSummary',
    component: () => import('./form-new/AppointmentSummary.vue'),
    meta: {
      seo: require('./seo/form-new/AppointmentSummary.json'),
    },
  },
  {
    path: '/documentacion/conexion-aeat',
    name: 'documentation.aeatOtp',
    component: () => import('./documentation/AeatOtp.vue'),
    meta: {
      seo: require('./seo/documentation/AeatOtp.json'),
    },
  },
];
